"use client";

import { useEffect } from 'react';
import { useNotificationConnection } from '../hooks/useNotificationConnection';
import { useGlobalContext } from '../../context';

/**
 * Component that handles WebSocket notification connections based on user authentication.
 * This must be rendered inside the ToastProvider to access toast functionality.
 */
export const NotificationManager: React.FC = () => {
  const { userData } = useGlobalContext();

  // Automatically connect to WebSocket notifications when user is authenticated
  const { isConnected } = useNotificationConnection({
    userId: userData?.userId || null,
    enabled: !!userData
  });

  // Optional: Log connection status for debugging
  useEffect(() => {
    if (userData?.userId) {
      console.log(`Notification connection for user ${userData.userId}:`, isConnected ? 'Connected' : 'Disconnected');
    } else {
        console.log('Notification connection: No user authenticated');
    }
  }, [isConnected, userData?.userId]);

  // This component doesn't render anything visible
  return null;
};
